import FixedAspectRatioImg from "@/ts/base/Components/FixedAspectRatioImg";

class BaseBlock {

	block!: HTMLElement;
	index!: number;

	protected fixedAspectRatioImg!: FixedAspectRatioImg;
	protected maintainAspectRatio: boolean = false;

    constructor(element: HTMLElement, index: number) {
		this.block = element;
		this.index = index;

		this.maintainAspectRatio = this.block.classList.contains("maintain-aspect-ratio");

		if (this.maintainAspectRatio) {
			const imgEl = this.block.querySelector(".maintain-aspect-ratio img");
			if (imgEl instanceof HTMLImageElement) {
				this.fixedAspectRatioImg = new FixedAspectRatioImg(imgEl);
			}

			window.addEventListener("resize", this.onWindowResize.bind(this));
			this.updateSize();
		}
    }

	get isAnimated(): boolean {
		return this.block.classList.contains("animated");
	}

    init(): void {
		throw new Error(this.block.dataset.block + " has not been initialized!");
    }

    getBlockDataId(): string {
        return <string>this.block.dataset.blockId;
    }

	getBlockType(): string {
		return <string>this.block.dataset.block;
	}

    getBlockSelector(subselect: string = ""): string {
        let selector = `section.acf-block[data-block-id="${this.getBlockDataId()}"]`;
        if (subselect !== "") {
            selector = selector.concat(` ${subselect}`);
        }
        return selector;
    }

	getComputedStyle(): CSSStyleDeclaration {
		return window.getComputedStyle(this.block);
	}

	updateSize(): void {
		this.block.style.minHeight = this.fixedAspectRatioImg.getRealHeight().toString().concat("px");
	}

	onWindowResize(): void {
		this.updateSize();
	}
}

export default BaseBlock;
